// src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi) // load /locales/{{lng}}/{{ns}}.json
  .use(LanguageDetector) // detect lang from query, storage, browser, etc.
  .use(initReactI18next) // pass i18n to react
  .init({
    fallbackLng: "en",
    supportedLngs: ["en", "ar"],
    ns: ["translation", "permissions"],
    defaultNS: "translation",
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: [
        "querystring",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: { useSuspense: true },
    // helpful while setting up
    debug: false,
  });

// keep <html lang> and dir in sync (for RTL like ar)
document.documentElement.lang = i18n.language;
document.documentElement.dir = i18n.dir();

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = i18n.dir(lng);
});

export default i18n;
